import React, { ReactNode } from 'react'

import styles from './index.module.css'

interface IActionProps {
  children: ReactNode
}

export const Action = (props: IActionProps) => {
  const { children } = props

  return <section className={styles.container}>{children}</section>
}

Action.displayName = 'Card.Action'
